import { Component, OnInit } from '@angular/core';
import { ConfigurationsFacadeService } from '@drl/shared/facades';
import { environment } from '@drl/env/environment';
import { UserSessionStoreService as StoreService } from '../../app/core/store/user-session-store.service';
import { ApiService } from '@drl/core/api/api.service';
import { TenantProfileAdapter } from '@drl/shared/adapters';
import { Subscription } from 'rxjs';

@Component({
  selector: 'support-box',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportBoxComponent implements OnInit {
  country: string;
  extension: string;
  phone: string;
  email: string;
  protected readonly _subscriptions: Subscription[] = [];

  constructor(
    private readonly configurationFacade: ConfigurationsFacadeService,
    private readonly store: StoreService,
    private readonly apiService: ApiService,
    private readonly tenProfileAdapter: TenantProfileAdapter,
  ) { }

  ngOnInit() {
    this.getTenantDetails();
  }

  getTenantDetails() {
    this._subscriptions.push(
      this.configurationFacade.getTenantDetailsByTenantKey(this.store.getTenantKeyName()).subscribe(res => {
        this.store.setTenantName(res.name);
        this.phone = res.phone || environment.supportPhone;
        this.country = res.country || ''
        this.email = res.supportEmail || environment.supportEmail;
        this.extension = res.extension || '';
      }),
    );
  }

}
